import { useCampaigns } from "@features/campaigns/api/use-campaigns";

/** ป้ายจำนวนแคมเปญบนหัวการ์ด section — "…" ระหว่างที่ยังโหลดไม่เสร็จ เหมือนของเดิม */
export function useCampaignCountLabel(brandId: string): string {
  const { data } = useCampaigns(brandId);
  return data ? `${data.length} แคมเปญ` : "…";
}
